import React from 'react';
import { OrderTable } from '@widgets/OrderTable';

export const OrderPage: React.FC = () => {
    return <OrderTable />;
};
